export enum ElementStyleType {
  Gray = 'gray',
  Bordered = 'bordered',
}
